const options = {
  5: "bg-cyan-200/5",
  10: "bg-cyan-200/10",
  25: "bg-cyan-200/25",
  50: "bg-cyan-200/50",
  75: "bg-cyan-200/75",
  90: "bg-cyan-200/90",
  100: "bg-cyan-200",
};

const from = {
  5: "from-cyan-200/5",
  10: "from-cyan-200/10",
  25: "from-cyan-200/25",
  50: "from-cyan-200/50",
  75: "from-cyan-200/75",
  90: "from-cyan-200/90",
  100: "from-cyan-200",
};

export default function getBackgroundCyan200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
